import { Link } from "react-router-dom";

const brands = [
  { text: "Michigan Plank Flooring", href: "/michigan-plank-flooring" },
  { text: "Dreamweaver Carpet", href: "/dreamweaver-carpet" },
  { text: "Lauzon", href: "/brands/lauzon" },
  { text: "Mercier", href: "/brands/mercier" },
  { text: "Viking", href: "/brands/viking" },
  { text: "Indusparquet", href: "/brands/indusparquet" },
  { text: "Olde Wood", href: "/brands/olde-wood" },
  { text: "Cali Vinyl", href: "/brands/cali" },
  { text: "Quick-Step", href: "/brands/quick-step" },
  { text: "Bella Cera", href: "/brands/bella-cera" },
  { text: "Bamboo Flooring", href: "/brands/ironwood" },
  { text: "Alterna", href: "/brands/alterna" },
];

const FooterBrands = () => (
  <div>
    <span
      className="text-[11px] font-semibold tracking-[0.08em] uppercase block mb-4"
      style={{ color: "var(--footer-text-tertiary)" }}
    >
      Brands
    </span>
    <ul className="flex flex-col">
      {brands.map((brand) => (
        <li key={brand.text}>
          <Link
            to={brand.href}
            className="text-[13px] leading-[2.2] inline-block transition-colors duration-150"
            style={{ color: "var(--footer-text-secondary)" }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--footer-gold)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--footer-text-secondary)")}
          >
            {brand.text}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default FooterBrands;
